import DashboardDropdown from '../../components/DashboardComponents/DashboardDropDown';
// import IconFile from '../../components/Icon/IconFile';
// import IconHome from '../../components/Icon/IconHome';

import QualityAuditorDashboardView1 from '../../components/pagecomponents/DashboardComp/QualityAuditor/QualityAuditorDashboardView1';
// import QualityAuditorDashboardView2 from '../../components/pagecomponents/DashboardComp/QualityAuditor/QualityAuditorDashboardView2';
// import QalityAuditorAccountstobeAuditedData from '../../Data/DashboardData/QualityAuditor/QalityAuditorAccountstobeAuditedData.json';
// import QualityAuditorAttandenceMeetingData from '../../Data/DashboardData/QualityAuditor/QualityAuditorAttandenceMeetingData.json';
// import QualityAuditorTimelineforMonthlyReportData from '../../Data/DashboardData/QualityAuditor/QualityAuditorTimelineforMonthlyReportData.json';

function QualityAuditorMainTab() {
  return (
    <>
      {/* Optional dropdown or filters can be enabled here */}
      {/* <DashboardDropdown /> */}

      {/* Directly render the main view */}
      <QualityAuditorDashboardView1 />
    </>
  );
}

export default QualityAuditorMainTab;
